import { createTheme } from '@mui/material/styles';
import Colors from '../constants/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.navyBlue.default,
    },
    secondary: {
      main: Colors.orange.default,
    },
    error: {
      main: Colors.red[600], //usually for text
      light: Colors.red[100],
    },
    success: {
      main: Colors.green[700], //usually for text
      light: Colors.green[100],
      dark: Colors.green[500],
    },
    background: {
      default: Colors.navyBlue.lightest,
    },
    text: {
      primary: Colors.black,
    },
  },
  typography: {
    fontFamily: 'Inter',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      margin: 0,
    },
    h2: {
      fontSize: '1.75rem',
      fontWeight: 700,
      margin: 0,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      margin: 0,
    },
    h4: {
      fontSize: '1.3rem',
      fontWeight: 500,
      margin: 0,
    },
    h5: {
      fontSize: '1.1rem',
      fontWeight: 500,
      margin: 0,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      margin: 0,
    },
    body1: {
      fontSize: '1rem',
      fontWeight: 400,
      margin: 0,
    },
    body2: {
      fontSize: '0.85rem',
      fontWeight: 400,
      margin: 0,
    }
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: 'Inter';
          font-style: normal;
          font-display: swap;
          font-weight: 400;
        }
      `,
    },
  },
});

export default theme;
